import { gql } from '@apollo/client'

const COMPANY_ENABLED_TABS = gql`
query companyQuery {
  company {
    id
    portfolioBenchmarkEnabled
    periodOverPeriodAnalysisEnabled
    competitorPriceAnalysisEnabled
    keyPerformanceMetricsEnabled
    stockAndDeliveriesEnabled
  }
}
`

export { COMPANY_ENABLED_TABS }
